var exports = {
  "_0": "is-stuck__Wfd5kJ",
  "oe": "show-when-stuck__KRJelx",
  "jU": "hide-when-stuck-large__j6Aqwi",
  "zk": "pr-title-details__HThJsz",
  "Eo": "pr-sticky-title__utkvoF",
  "yF": "divider__wf86L3",
  "t1": "hide-commit-selector-on-small__C9Yl2a",
  "KU": "updatedHeaderToolbar__5Xcutd",
  "zc": "hide-icon-on-small__53kfy_",
  "dT": "hide-commit-selector-on-medium__7ZcBC2",
  "cM": "show-more-menu-on-small__4l8RVM",
  "_G": "show-more-menu-on-medium__7zmfMI",
  "Og": "hide-viewed-progress-on-small__u9jCpF",
  "Rr": "container-show-on-sm__KdbhTY",
  "Un": "file-controls__C6Wwfn",
  "H5": "file-controls-navigation__SxrOr4",
  "$n": "hide-file-controls-on-small__XvkRMW",
  "Wy": "file-controls-divider__iGaBhT",
  "KE": "toolbar__UgdeAp",
  "nl": "simple-toolbar__ml6rTC",
  "ql": "stickyHeaderActivationThreshold__C384bX",
  "w_": "show-on-xlarge__1X0kd7",
};

module.exports = exports;
